// extracted by mini-css-extract-plugin
export default {"container":"styles_container__DkHS3","close":"styles_close__nqbvo","search_results":"styles_search_results__AdXLm","skeleton":"styles_skeleton__R+EG7"};